import jQuery from 'jquery';
import {AusCents, AusDollar, HashUrl, JsonDate} from "./types";
import printf from "printf";
import PlainObject = JQuery.PlainObject;

/**
 * Obtain the HashUrl from the window. This omits the leading # (but should start with a /)
 */
export function windowHashUrl() : HashUrl {
    const hash = window.location.hash || "#";
    const url = hash.replace(/^#/, "");
    return url;
}

export function hashUrlToUrl(h: HashUrl) : string {
    const url0 = window.location.href;
    const url = url0.replace(/(#.*)?$/, "#" + h);
    return url;
}

/**
 * Obtain the parts of the HashUrl separated by /.
 * @param url
 */
export function path(url: HashUrl) : Array<string> {
    const url2 = url.replace(/^\//, "");
    const path_raw = url2.split('/');
    const path = path_raw.map(x => decodeURIComponent(x));
    return path;
}

export function pushHash(h: HashUrl) {
    window.location.hash = (h ? "#" + h : "#");
}

export function replaceHash(h: HashUrl) {
    const url = hashUrlToUrl(h);
    window.history.replaceState(null, "", url);
}

export function formToJson(form: JQuery<HTMLElement>, json: any) {
    const formData = form.serializeArray();

    for (const i in formData) {

        const sel = "*[name='" + formData[i].name + "']";
        const field = form.find(sel).addBack(sel);

        const valRaw = formData[i].value;

        // Type conversions:

        // If the field has class "number" then the value is parsed as a number.
        // Additionally if it has class "integer" then it is parsed as integer

        // Any checkboxes with the class "boolean" are serialized as either true or false.
        // Note that this is different to normal checkbox behaviour in which the
        // control is not submitted if not checked.

        const isNumber = field.hasClass("number");
        const isInteger = isNumber && field.hasClass("integer");
        const isMoney = isNumber && field.hasClass("money");
        const isDate = field.hasClass("datefield");
        const isBoolean = field.hasClass("boolean");
        const isMultiple = field[0].nodeName == "SELECT" && field.attr("multiple") !== undefined;

        let val;

        if (isNumber) {

            let val0 = valRaw;

            if (isMoney && val0) {
                val0 = val0.replace("$", "");
            }

            const re = isInteger ? / *-?[0-9]+ */ : / *-?([0-9]+|[0-9]*\.[0-9]+ *)/;

            if (val0 != null && val0.match(re)) {
                val = Number(val0);
            } else {
                val = null;
            }

        } else if (isDate) {

            // Convert dd/mm/yyyy to yyyy-mm-dd
            if (valRaw && valRaw.match(/\//)) {
                val = parseDate(valRaw);
            } else {
                val = valRaw;
            }
        } else if (isBoolean) {

            // expected values are "true", "false" and "" (or null)
            if (valRaw === "true") {
                val = true;
            }
            if (valRaw === "false") {
                val = false;
            }

        } else {

            val = valRaw;

        }

        if (isMultiple) {

            if (json[formData[i].name] === undefined) {
                json[formData[i].name] = [];
            }
            if (json[formData[i].name].push) {
                json[formData[i].name].push(val);
            } else {
                // maybe name conflict? anyway we don't want to crash
                json[formData[i].name] = val;
            }

        } else {

            // normal case
            json[formData[i].name] = val;
        }


        // Now handle checkboxes of type boolean

        const booleans = form.find("input.boolean[type=checkbox]").not(":disabled");

        booleans.each((i, b) => {
            const name = jQuery(b).attr("name") as string;
            const val = jQuery(b).is(":checked") ? true : false;
            json[name] = val;
        });

    }

}

/**
 * Crude but effective to reload data (eg after update).
 * We can replace uses of this with something more sophisticated later.
 */
export function reloadWindow(url?: HashUrl) {
    if (! url) {
        window.location.reload();
    } else {
        const absUrl = window.location.href.replace(/#.*/, "") + "#" + url;
        window.location.href = absUrl;
        window.location.reload();
    }
}

export function openNewWindow(url: HashUrl) {
    const absUrl = window.location.href.replace(/#.*/, "") + "#" + url;
    window.open(absUrl);
}

/**
 * JsonDate is string for format yyyy-mm-dd.
 * We render as dd/mm/yyyy
 */
export function renderDate(d: JsonDate | undefined) {
    if (! d) {
        return d;
    }
    const bits = d.trim().split(/-/);
    return bits[2] + "/" + bits[1] + "/" + bits[0];
}

/**
 * Parse ddmmyyyy date into JsonDate (yyyy-mm-dd)
 * @param d
 */
export function parseDate(d: string | undefined) {
    if (! d) {
        return d;
    }
    const bits = d.trim().split(/\//);
    return bits[2] + "-" + bits[1] + "-" + bits[0];
}

/**
 * Render a unix timestamp as a time - eg "5 wrbminutes ago", "3 hours ago" or "24/02/2019",
 * depending on age.
 * @param ts
 */
export function renderTimestamp(ts: number) {
    const then = ts * 1000;
    const now = Date.now();

    const diff = now - then;

    // Segment rendering according to age:

    // < 1 hour - x minutes ago
    // < 24 hours - x hours ago
    // then dd/mm/yyyy

    const minutes = diff / 1000 / 60;
    const hours = minutes / 60;

    if (hours < 1) {
        const mins = Math.floor(minutes);
        return mins + " " + plural(mins, "minute", "minutes") + " ago";
    }
    if (hours < 24) {
        const h = Math.floor(hours);
        return h + " " + plural(h, "hour", "hours") + " ago";
    }

    function r(x: number) {
        const s = x.toString();
        return s.length < 2 ? "0" + s : s;
    }

    const d = new Date(then);
    return r(d.getDate()) + "/" + r(d.getMonth()+1) + "/" + r(d.getFullYear()) + " " + r(d.getHours()) + ":" + r(d.getMinutes()) + ":" + r(d.getSeconds());
}

export function renderTimestampDay(ts: number) {
    const then = ts * 1000;
    const d = new Date(then);
    return d.getDate();
}
export function renderTimestampMonth(ts: number) {
    const then = ts * 1000;
    const d = new Date(then);
    const m = d.getMonth();
    return monthNames[m];
}


export function renderCents(cents: AusCents) : string {
    return printf((cents < 0 ? "-" : "") + "$%.2f", Math.abs(cents) / 100);
}

export function renderDollars(dollars: AusDollar) : string {
    return printf((dollars < 0 ? "-" : "") + "$%.2f", Math.abs(dollars));
}

export function renderTimeInterval(seconds : number | undefined) {
    if (seconds === undefined) {
        return "";
    }
    const minutes = Math.round(seconds / 60);

    const mins = minutes % 60;
    const hours = (minutes - mins) / 60;
    const bits = [];
    if (hours > 0) {
        bits.push(hours + " " + plural(hours, "hr", "hr"));
    }
    if (mins > 0) {
        bits.push(mins + " " + plural(mins, "m", "m"));
    }
    return bits.join(" ");
};


export function dollarsToCents(dollars: string | undefined) : number | undefined {
    let cents = undefined;
    dollars = dollars && dollars.replace("$", "");
    if (dollars && dollars.length > 0) {
        cents = Math.round(+dollars * 100);
    }
    return cents;
}

export const monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

export function plural(x: number, singular: string, plural: string) {
    return x == 1 ? singular : plural;
}

/**
 * A promise that is always already resolved with no value.
 */
export const emptyPromise = new Promise(((resolve, reject) => resolve(undefined)));

/**
 * A promise that is always resolved with the given value
 */
export function immediatePromise<T>(arg: T): Promise<T> {
    return new Promise(((resolve, reject) => resolve(arg)));
}

export function disable(button: JQuery<HTMLElement> | HTMLElement, promise: Promise<any>) {
    jQuery(button).prop("disabled", true);
    promise.finally(() => {
        jQuery(button).prop("disabled", false);
    });
}

export function pipe(x: PlainObject) : PlainObject {
    const json = JSON.stringify(x);
    const out = JSON.parse(json);
    return out;
}

export function loadExternalScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
        const scriptElement = document.createElement("script")
        scriptElement.src = scriptUrl
        scriptElement.onload = resolve
        document.body.appendChild(scriptElement)
    });
}

export function scrollTo(elt: JQuery<HTMLElement>, duration?: number) {
    if (duration === undefined) {
        duration = 100;
    }
    const offset = elt.offset();
    if (offset) {
        jQuery("html, body").animate({
            scrollTop: offset.top
        }, duration);
    }
}

export function paramsToQueryString(params: any) {
    const keys = Object.keys(params);
    if (keys.length == 0) {
        return "";
    }
    return "?" + keys.map((key) => key + "=" + encodeURIComponent(params[key])).join("&");
}
